import { useCallback, useEffect, useState } from 'react';

import fontStyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/SearchBox.module.scss';

const Note = ({ item }) => {
    const [imageSrc, setImageSrc] = useState(item.image);
    const [hasTriedDefault, setHasTriedDefault] = useState(false);

    // If there's no initial image, set the default image immediately
    useEffect(() => {
        if (!item.image) {
            loadDefaultImage();
        }
    }, [item.image]);

    const loadDefaultImage = async () => {
        if (hasTriedDefault) {
            return;
        };

        setHasTriedDefault(true);

        try {
            const defaultImageModule = await import(
                'static/img/sections/related-notes/default-1.webp'
            );
            setImageSrc(defaultImageModule.default);
        } catch (error) {
            // If dynamic import fails, try a fallback path
            try {
                setImageSrc(
                    require('static/img/sections/related-notes/default-1.webp')
                );
            } catch (_error) {
                setImageSrc(null);
            }
        }
    };

    const handleImageError = useCallback(async () => {
        if (!hasTriedDefault) {
            await loadDefaultImage();
        }
    }, [hasTriedDefault]);

    return (
        <a
            className={styles.note}
            target="_blank"
            href={item.url}
            rel="noreferrer"
            aria-label={item.title}
        >
            <div className={styles.image_container}>
                <Image
                    // We accept to send image src null to make it work with the default image
                    src={imageSrc}
                    width={200}
                    height={130}
                    alt={item.title}
                    style={{ width: '100%', height: 'auto' }}
                    strategy="lazyLoading"
                    onError={handleImageError}
                    acceptNullSrc
                />
            </div>
            <Spacer />
            <h2 className={fontStyles.text_header6}>{item.title}</h2>
            <p className={fontStyles.text_small}>{item.description}</p>
        </a>
    );
};

Note.propTypes = {
    item: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        image: PropTypes.string,
        description: PropTypes.string.isRequired
    })
};

export default Note;
